<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="detailBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">关联用户表</div>
      </div>
        <div class="page-action-btns flex margin-tb-10">
          <div class="flex-grow-1"></div>
          <button
              class="common-bg-button"
              @click="() => { showMultiQuery = !showMultiQuery }"
          >
            高级筛选
          </button>
          <button
              class="common-bg-button"
              @click="toExportList()"
          >
            导 出
          </button>
        </div>
        <!-- 高级筛选 -->
        <div
            class="multi-query-div el-fade-in-linear"
            v-if="showMultiQuery"
        >
          <div class="margin-bottom-16">
            <el-row :gutter="20">
              <el-col :span="8">
                <p class="margin-bottom-5 font-14">关键字搜索</p>
                <el-input
                    clearable
                    v-model="queryInfo.searchKey"
                    size="small"
                    class="full-width"
                    placeholder="请输入用户手机号/用户姓名"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <p class="margin-bottom-5 font-14">关键动作</p>
                <el-select
                    v-model="queryInfo.relateOperation"
                    size="small"
                    clearable
                    multiple
                    class="full-width"
                    placeholder="请选择订单状态"
                >
                  <el-option
                      v-for="a in orderStatusList"
                      :key="a.code"
                      :label="a.title"
                      :value="a.code"
                  >
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="8">
                <p class="margin-bottom-5 font-14">创建时间</p>
                <div class="full-width">
                  <el-date-picker
                      v-model="queryInfo.createFromTime"
                      type="datetime"
                      size="small"
                      prefix-icon="el-icon-date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期时间"
                      class="flex-1"
                  >
                  </el-date-picker>
                  <span class="time-query-line" style="line-height: 32px"> - </span>
                  <el-date-picker
                      v-model="queryInfo.createToTime"
                      type="datetime"
                      size="small"
                      prefix-icon="el-icon-date"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期时间"
                      class="flex-1"
                  >
                  </el-date-picker>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="query-flex-btns-div margin-bottom-16" style="display: flex; justify-content: flex-end">
            <button class="common-bg-button" @click="getListData(pagination, true)">
              搜 索
            </button>
            <button class="common-bg-button" @click="resetQuery()">
              重 置
            </button>
          </div>
        </div>
        <!-- 表格 -->
        <div class="list-table">
          <el-table :data="tableData" style="width: 100%" border stripe>
            <el-table-column type="index" width="40" align="center" fixed="left" />
            <el-table-column prop="shareUserMobile" label="用户手机号" align="center">
              <div
                  slot="header"
                  style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
              >
                <span style="margin-right: 8px">用户手机号</span>
                <img
                    style="cursor: pointer;width: 20px; height: 20px"
                    src="../../../assets/app-card-style/眼睛_隐藏.png"
                    alt=""
                    v-if="!isFlag"
                    @click="flagChange('1')"
                />
                <img
                    style="cursor: pointer;width: 20px; height: 20px"
                    src="../../../assets/app-card-style/眼睛_显示.png"
                    alt=""
                    v-if="isFlag"
                    @click="flagChange('1')"
                />
              </div>
              <template slot-scope="scope">
                <span v-if="isFlag">{{ scope.row.shareUserMobile }}</span>
                <span v-else>{{
                    scope.row.shareUserMobile
                        ? scope.row.shareUserMobile.replace(
                            scope.row.shareUserMobile.substring(2, 9),
                            "*******"
                        )
                        : ""
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="relateUserName" label="关联用户姓名" align="center" />
            <el-table-column prop="relateUserMobile" label="关联用户手机号" align="center" >
              <div
                  slot="header"
                  style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
              >
                <span style="margin-right: 8px">关联用户手机号</span>
                <img
                    style="cursor: pointer;width: 20px; height: 20px"
                    src="../../../assets/app-card-style/眼睛_隐藏.png"
                    alt=""
                    v-if="!isSecondFlag"
                    @click="flagChange('2')"
                />
                <img
                    style="cursor: pointer;width: 20px; height: 20px"
                    src="../../../assets/app-card-style/眼睛_显示.png"
                    alt=""
                    v-if="isSecondFlag"
                    @click="flagChange('2')"
                />
              </div>
              <template slot-scope="scope">
                <span v-if="isSecondFlag">{{ scope.row.relateUserMobile }}</span>
                <span v-else>{{
                    scope.row.relateUserMobile
                        ? scope.row.relateUserMobile.replace(
                            scope.row.relateUserMobile.substring(2, 9),
                            "*******"
                        )
                        : ""
                  }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="relateOperation" label="关联动作" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.relateOperation === 'SIGN'">报名成功</span>
                <span v-if="scope.row.relateOperation === 'ACTIVATED'">激活成功</span>
              </template>
            </el-table-column>
            <el-table-column prop="createdWhen" label="创建时间" align="center" />
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="list-pagination">
          <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData" />
        </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      isFlag: false,
      isSecondFlag: false,
      detailBreadCrumb: pageConfig.detailBreadCrumb,
      pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      showMultiQuery: false,
      orderStatusList: [
        { code: "SIGN", title: "报名成功" },
        { code: "ACTIVATED", title: "安装成功" },
      ],
    };
  },
  mounted() {
    this.getListData(this.pagination, true);
  },
  methods: {
    resetQuery() {
      this.queryInfo = {};
      this.getListData(this.pagination, true);
    },

    flagChange(type) {
      let _ = this;
      if(type === '1') _.isFlag = !_.isFlag;
      if(type === '2') _.isSecondFlag = !_.isSecondFlag;
    },

    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.$H.post(_, _.$A.zeropay.userRelationList, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    // 导出
    toExportList() {
      let _ = this;
      let urls = "";
      const host = window.location.hostname;
      if (host.includes("shzhida.com")) {
        urls = "http://ocharge.shzhida.com:6777";
      } else {
        urls = "http://192.168.8.174:7997";
      }
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.zeropay.userRelationExcel, _.queryInfo).then((res) => {
        _.$U.saveExcelFile(res.data.data);
        // var downUrl = "http://192.168.8.174:7997" + res.data.data.filePath;
        var downUrl = urls + res.data.data.filePath;
        window.open(downUrl, "_blank");
        _.$U.hideLoading(_);
      });
    },

  },
};
</script>

<style lang="less" scoped>
.title-div {
  font-weight: 600;
  margin: 10px 0 10px;
  font-size: 26px;
  flex-grow: 1;
  color: #000;
  height: 30px;
}

.top-select-title {
  font-weight: 600;
  font-size: 20px;
  color: #000;
  margin-bottom: 40px;
  margin-right: 48px;
  cursor: pointer;
}

.active {
  color: #4182eb;
}

.pileItem-div {
  font-weight: 600;
  //   margin: 0 10px !important;
  font-size: 20px;
  // flex-grow: 1;
  color: #000;
  // height: 30px;
}
.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;
  > div:first-of-type {
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    width: 160px;
    line-height: 32px;
  }
  > div:last-of-type {
    flex: 1;
    font-size: 14px;
    min-width: 160px;
    line-height: 32px;
  }
}

.cust-detail-title {
  width: 160px;
  line-height: 32px;
  font-weight: 700;
}
.cust-detail-value {
  flex: 1;
  line-height: 32px;
  word-break: break-all;
  display: flex;
  // justify-content: center;
  align-items: center;
}

.margin-r-10 {
  margin-right: 10px;
}

.flex-orderno-line-div {
  display: flex;
  border-bottom: 1px solid #555;
  padding-bottom: 16px;
  margin-bottom: 16px;

  .line-child-order-no-title {
    font-weight: 600;
    font-size: 26px;
    color: #000;
    height: 30px;
    margin-right: 60px;
  }
  .line-child-order-no-value {
    font-weight: 600;
    font-size: 26px;
    color: #000;
    height: 30px;
    flex: 1;
  }
}

.padding-top-10 {
  padding-top: 10px;
}

.xy-card-div {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 16px;
  box-sizing: border-box;

  border: 1px solid #ddd;
  border-radius: 16px;

  margin-top: 16px;

  .item-card {
    width: calc(100% / 4);
    display: flex;
    flex-direction: column;
    align-items: center;

    border-right: 1px solid #ddd;

    div:first-child {
      line-height: 32px;

      span {
        font-size: 24px;
        line-height: 32px;
        margin: 0 16px;
      }
    }
  }

  .item-card:last-child {
    border-right: none;
  }
}
</style>
